<template>
  <div class="setting-page-content company-tax-account-setting">
    <h5 class="mb-3">{{ $t('user.taxAuthorityAccount') }}</h5>
    <p v-if="!isConnected" class="desc">{{ $t('user.notConnected') }}</p>
    <p v-if="isConnected" class="desc">
      {{ $t('user.account') }}
      <b>{{taxAccountUserName}}</b>
      {{ $t('user.connected') }}
      {{syncDate}}
      <br/>
      <a class="link" href="javascript:" @click="showUpdateForm = true">
        {{ $t('user.updateTaxAuthorityAccount') }}
      </a>
    </p>
    <div v-if="!isConnected || showUpdateForm" class="row">
      <div class="col-6">
        <app-form
          ref="form"
          @on-submit="onSubmit"
          :schema="schema"
          :data="formModel"
        />
      </div>
    </div>
    <div class="setting-footer">
      <button @click="save()" :disabled="isUpdating" class="btn btn-primary btn-sm">
        {{isConnected ? this.$t('app.update') : this.$t('app.connect')}}
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import AppForm from '@/components/app-form/';
import AccountProxy from '@/store/proxies/account-proxy';

export default {
  name: 'CompanyTaxAccountSetting',
  components: {
    AppForm,
  },
  data() {
    return {
      taxAccountUserName: '',
      taxAccountSyncDate: '',
      isConnected: false,
      showUpdateForm: false,
      formModel: {
        user_name: null,
        password: null,
      },
      schema: [
        {
          name: 'user_name',
          label: this.$t('user.username'),
          placeholder: `${this.$t('app.enter')} ${this.$t('user.username')}`,
          type: 'input',
          validation: 'required',
        },
        {
          name: 'password',
          label: `${this.$t('user.password')}`,
          placeholder: `${this.$t('app.enter')} ${this.$t('user.password')}`,
          type: 'input',
          inputType: 'password',
          validation: 'required',
        },
      ],
      isUpdating: false,
    };
  },
  created() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser && currentUser.company && currentUser.company.tax_code) {
      this.taxAccountUserName = currentUser.company.tax_code;
      this.formModel.user_name = currentUser.company.tax_code;
    }

    new AccountProxy().checkValidTaxAccount().then((res) => {
      if (res) {
        localStorage.setItem('startDateSynchronized', res.start_date_synchronized);
        this.setState({
          checkValid: res,
          startDateSynchronized: res.start_date_synchronized,
        });
      }
      if (!res.expired) {
        this.isConnected = true;
        this.taxAccountSyncDate = res.start_date_synchronized;
      }
    }, () => {});
  },
  computed: {
    syncDate() {
      if (this.isConnected && this.taxAccountSyncDate) {
        const date = this.taxAccountSyncDate.split('-');
        return `${date[2]}-${date[1]}-${date[0]}.`;
      }
      return '';
    },
  },
  methods: {
    ...mapActions('auth', ['updateCompanyTaxAccount', 'setState']),
    onSubmit(formModel) {
      this.isUpdating = false;
      this.$refs.form.validate().then((isValid) => {
        if (isValid) {
          this.isUpdating = true;

          if (this.isConnected) {
            this.updateCompanyTaxAccount(formModel).then(() => {
              this.isUpdating = false;
            }).catch(() => {
              this.isUpdating = false;
            });
          } else {
            const payload = {
              user_name: formModel.user_name,
              password: formModel.password,
              invoices_sold: true,
              invoices_purchase: true,
              start_date_synchronized: '2023-10-01',
            };
            new AccountProxy().connectTaxAccount(payload).then((res) => {
              this.isConnected = true;
              setTimeout(() => {
                this.taxAccountUserName = res.user_name;
                this.taxAccountSyncDate = res.start_date_synchronized;
              }, 100);
              sessionStorage.setItem('isConnectTaxAccount', '1');
              this.isUpdating = false;
            }).catch(() => {
              this.isUpdating = false;
            });
          }
        }
      });
    },
    save() {
      if (this.isUpdating) {
        return;
      }
      this.$refs.form.submit();
    },
  },
};
</script>
<style lang="scss">
.setting-page-content {
  h5 {
    color: #0078D4;
    font-size: 16px;
    font-weight: bold;
  }
  display: flex;
  flex-direction: column;
  height: 75vh;
  overflow-y: scroll;
  .setting-footer {
    text-align: right;
    margin-top: auto;
    padding-bottom: 1rem;
  }
}
.company-setting form{
  padding-right: 1rem;
}
.desc {
  font-size: 13px;
  text-align: center;
  padding: 1rem;
  background: #CCE4F6;
  border-radius: 8px;
}

.company-tax-account-setting {
  padding: 0 2rem;
}
</style>



// WEBPACK FOOTER //
// src/portal-components/setting/company-tax-account-setting.vue